import type { ReactNode } from "react";
import { MicroLabel } from "../ui/Text";

/**
 * A panel figure: one size down from the masthead's `Metric`, because a panel holds
 * several and the masthead's scale is reserved for the four the page leads with.
 * Renders a `dt`/`dd` pair's wrapper, so it belongs inside a `dl`.
 */
export function Figure({
  label,
  value,
  unit,
  sub,
}: {
  readonly label: string;
  readonly value: string;
  readonly unit?: string | undefined;
  /** A second line under the figure: a count, a qualifier. */
  readonly sub?: ReactNode;
}) {
  return (
    <div className="flex flex-col gap-1 border-t border-rule pt-2">
      <MicroLabel as="dt">{label}</MicroLabel>
      <dd className="m-0 flex flex-col">
        <span className="font-display text-title font-semibold text-ink tabular-nums">
          {value}
          {/* No unit beside a dash: "— kWh" reads as a broken figure, not as none. */}
          {unit === undefined || value === "—" ? null : (
            <span className="ml-1 font-sans text-body font-medium text-ink-faint">{unit}</span>
          )}
        </span>
        {sub === undefined ? null : <span className="text-data text-ink-faint">{sub}</span>}
      </dd>
    </div>
  );
}
